"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _blocklist = _interopRequireDefault(require("./blocklist"));
var _deploymentsLog = _interopRequireDefault(require("./deploymentsLog"));
var _messageLog = _interopRequireDefault(require("./messageLog"));
var _pageVisit = _interopRequireDefault(require("./pageVisit"));
var _permissionsLog = _interopRequireDefault(require("./permissionsLog"));
var _resourceView = _interopRequireDefault(require("./resourceView"));
var _shortUrls = _interopRequireDefault(require("./shortUrls"));
var _usersLog = _interopRequireDefault(require("./usersLog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Component = function Component() {
  var tabList = [_usersLog["default"], _pageVisit["default"], _resourceView["default"], _messageLog["default"], _shortUrls["default"], _deploymentsLog["default"], _permissionsLog["default"], _blocklist["default"]];
  return /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: tabList,
    saveInHash: true
  });
};
var _default = exports["default"] = Component;